import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hb-custom-dialog',
  templateUrl: 'customDialog.component.html',
})
export class CustomDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CustomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  close(value: any): void {
    this.dialogRef.close(value);
  }
}
